import React, { useEffect, useState } from 'react';
import t from '@jetshop/intl';
import { styled } from 'linaria/react';
import { ReactComponent as Carrot } from '../../../svg/Carrot.svg';
import { StepHeader } from './StepHeader';
import { StepHeaderTextDescription } from '../Elements/StepHeaderTextDescription';
import { Item } from '../Elements/Item';
import Category3DConfig from '../Config/category.config';

const StyledWrapperStepTwo = styled('div')`
    display: flex;
    flex-direction: column;
    margin: 0 auto 4rem;
  
  `
const StepHeaderText = styled('div')`
    font-weight: bold;
    font-size: 18px;

  @media screen and (max-width: 800px) {
    font-size: 16px;
    width: 100%;
    margin: 0 40px 0 0;
  }
  `

const StepHeaderButton = styled('div')`
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    border-radius: 50px;
    margin: 0 auto;
    background: #911827;
    width: 100px;
    position: absolute;
    right: 0;
    cursor: pointer;
    display: ${({ active }) => (active ? 'flex' : 'none')};
  @media screen and (max-width: 800px) {
    top: 50%;
    transform: translateY(-50%);
  }
  `
const StepHeaderButtonText = styled('p')`
    margin: 5px 0;
    color: #fff;
  `
const SvgWrapper = styled('div')`
  width: 15px;
  transition: transform 0.3s;

  svg {
    use {
      fill: #fff;
    }
  }
  transform: rotate(-90deg);
`;
const ProductWrapper = styled('div')`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
  
  @media screen and (max-width: 800px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
  }
  @media screen and (max-width: 600px) {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }
  `

export const CategoryStepTitle = t('Typ av soffa');
export const CategoryStep = ({ currentStep, setCurrentStep, activeProduct, setActiveProduct, activeCategory, setActiveCategory, activeTextileIndex, setActiveTextileIndex, activeLeg, setActiveLeg }) => {
  let categories = Category3DConfig

  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {

  }, [activeIndex]);

// Render loading until client-only data is ready
  if (typeof window === 'undefined') {
    return <div>Loading...</div>;
  }


  return (
    <>
      <StyledWrapperStepTwo id="3d-wrapper">
        <StepHeader>
          <div></div>
          <StepHeaderText>{t('Typ av soffa')}<StepHeaderTextDescription>1/5</StepHeaderTextDescription></StepHeaderText>
          <StepHeaderButton active={activeIndex !== null ? 1 : 0} onClick={() => {
          } }>
            <StepHeaderButtonText>{t('Nästa')}</StepHeaderButtonText>
            <SvgWrapper>
              <Carrot />
            </SvgWrapper>
          </StepHeaderButton>
        </StepHeader>
        <ProductWrapper>
          {categories.map((category, index) => (
            <Item
              key={index}
              item={category}
              onClick={() => {
                if (index === activeIndex) {
                  setActiveIndex(null);
                  setActiveCategory(null);
                } else {
                  setActiveIndex(index);
                  setActiveCategory(categories[index].name);
                  window.sessionStorage.setItem('lastStep', currentStep);
                  setCurrentStep((i) => i + 1);
                }
              }}
              isActive={activeIndex === index}
            />
          ))}
        </ProductWrapper>
      </StyledWrapperStepTwo>
    </>
  );
}